/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Existing_Step2Inputs */

const en_existing_step2 = /** @type {(inputs: Existing_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open your agent in the project folder`)
};

const id_existing_step2 = /** @type {(inputs: Existing_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka agent di folder proyek`)
};

/**
* | output |
* | --- |
* | "Open your agent in the project folder" |
*
* @param {Existing_Step2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const existing_step2 = /** @type {((inputs?: Existing_Step2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Existing_Step2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_existing_step2(inputs)
	return en_existing_step2(inputs)
});